
import Vue from 'vue'
import { mapState } from 'vuex'
import logo from '../assets/logo.svg'

export default Vue.extend({
  data() {
    return {
      logo_url: this.$store.state.project.logo_url || logo,
    }
  },
  methods: {
    navigateToChannelHome() {
      const channelSlug = this.$route.params.channelSlug
      const path = `/c/${channelSlug}`
      this.$router.push({ path })
    },
  },
})
